import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Table, Spinner, Pagination, Alert, Badge } from 'react-bootstrap';
import { BsChatSquareText } from 'react-icons/bs';
import AdminLayout from '../components/AdminLayout';
import api from '../lib/api';

function WidgetChatsPage() {
  const { token } = useParams();
  const [chats, setChats] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [widgetName, setWidgetName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchChats = async () => {
    try {
      setLoading(true);
      setError('');

      const res = await api.get(`/admin/widgets/chats/${token}/`, {
        params: { page },
      });

      const data = res.data || {};
      setChats(data.results || []);
      setTotalPages(Math.max(1, Math.ceil((data.count || 0) / 10)));
      setWidgetName(data.widget_name || data.site || '');
    } catch (err) {
      setError('Failed to fetch widget chat logs.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChats();
  }, [page, token]);

  return (
    <AdminLayout
      title="Widget Chat Logs"
      subtitle={`Review chat history for widget token: ${token}`}
    >
      {error ? <Alert variant="danger">{error}</Alert> : null}

      <Card className="admin-surface-card">
        <Card.Body>
          <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
            <BsChatSquareText className="fs-4 text-primary" />
            <h5 className="mb-0 fw-bold">
              {widgetName ? `${widgetName} Chat Conversations` : 'Widget Conversations'}
            </h5>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : chats.length ? (
            <>
              <div className="table-responsive">
                <Table hover className="admin-table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Guest</th>
                      <th>Email</th>
                      <th>Question</th>
                      <th>Response</th>
                      <th>Feedback</th>
                    </tr>
                  </thead>
                  <tbody>
                    {chats.map((chat) => (
                      <tr key={chat.id}>
                        <td>{new Date(chat.created_at).toLocaleString()}</td>
                        <td>{chat.guest_name || '-'}</td>
                        <td>{chat.email || '-'}</td>
                        <td style={{ minWidth: 220 }}>{chat.question}</td>
                        <td style={{ minWidth: 260 }}>{chat.response}</td>
                        <td>
                          {chat.feedback === 'positive' ? (
                            <Badge bg="success" className="px-3 py-2 rounded-pill">
                              Positive
                            </Badge>
                          ) : chat.feedback === 'negative' ? (
                            <Badge bg="danger" className="px-3 py-2 rounded-pill">
                              Negative
                            </Badge>
                          ) : (
                            <Badge bg="secondary" className="px-3 py-2 rounded-pill">
                              None
                            </Badge>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {totalPages > 1 ? (
                <Pagination className="justify-content-center mt-4">
                  {Array.from({ length: totalPages }).map((_, i) => (
                    <Pagination.Item
                      key={i + 1}
                      active={i + 1 === page}
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              ) : null}
            </>
          ) : (
            <div className="text-center py-4 text-muted">
              No chat logs found for this widget yet.
            </div>
          )}
        </Card.Body>
      </Card>
    </AdminLayout>
  );
}

export default WidgetChatsPage;